<div id="page-wrapper" [ngClass]="{'open': toggle}">

    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar">
            <li class="sidebar-main">
                <a (click)="toggleSidebar()"  >
                    Operator Interface
                    <!-- <span title={{menuTitle}} class="menu-icon glyphicon glyphicon-transfer"></span> -->
                    <span title={{menuTitle}}><i class="fa fa-exchange" aria-hidden="true"></i></span>
                </a>
			</li>
			
			<!-- 
			  -- Station Dashboard
			  -->
			<li class="sidebar-list">
				<div class="routing-group">
					<a role="button" (click)="goToRouterLink('/stationDashboard//-999')" title="Display station dashboard" id="stationDashboardGroup">Station Dashboard<span class="menu-icon fa fa-tachometer"></span></a>
				</div>
			</li>
			
			<!-- 
			  -- Station Summary
			  -->
			<li class="sidebar-list">
				<div class="routing-group">
					<a role="button" (click)="goToRouterLink('/stationTable')" title="Display station summary" id="stationSummaryGroup">Station Summary<span class="menu-icon fa fa-table"></span></a>
				</div>
			</li>

			<!-- 
			  -- System Reports
			  -->
			<li class="sidebar-list">
				<div class="routing-group">
					<a role="button" (click)="goToRouterLink('/systemReports')" title="Display list of available system reports">System Dashboard<span class="menu-icon fa fa-bell"></span></a>
				</div> 
			</li>

			<!-- 
			  -- Templates
			  -->
			<li class="sidebar-list">
				<div class="routing-group">
					<a role="button" (click)="goToRouterLink('/dashboardTemplate')" title="Display custom dashboards" id="customDashboardGroup"
					data-cy="customDashboardGroup">My Dashboards<span class="menu-icon fa fa-cubes"></span></a>
				</div>

				<div id="dashboardTemplateCollapse" class="collapse">

					<!-- This selector allows Operator to dynamically create the templates list -->
					<ng-template dashboardTemplate-host></ng-template>

				</div>
			</li>

			<!-- 
			  -- Impact Summary
			  -->
			<li [ngClass]="{doNotCreate:!displayFloodImpactSummary}" class="sidebar-list">
				<div class="routing-group">
					<a role="button" (click)="goToRouterLink('/impactTable/-999')" title="Display impact table">Impact Summary<span class="menu-icon fa fa-exclamation-triangle"></span></a>
				</div> 
			</li>
          
			<li class="sidebar-list">
				<div class="routing-group">
					<a role="button" (click)="goToRouterLink('/map')" title="Display map">  <!-- a router listener is setup in each routerLink to also expand/collapse the below div  -->
					Map<span class="menu-icon fa fa-globe"></span></a>  <!-- fa-map -->
				</div> 
				
				
				<div id="mapCollapse" class="collapse">
					<!-- 
				  	-- Legend Checkbox
				  	-->
					<div class="checkbox"><label><input type="checkbox" id="toggleLegend" (click)="menuControlSelected($event)">Show legend</label></div>

					<!-- 
				  	-- Quick zoom
				  	-->
						<span id="quickZoom" [ngClass]="{doNotDisplay:!quickZoomVisible}" title="Zoom map to specified area">
							<label id="quickZoomLabel" style="margin-top: 5px">Quick zoom:
							</label>

							<div style="display:block; color:#30426a">
								<p-select appendTo="body"
								 	#zoomDropdown
									class="menuDropdown" id="zoomDropdown"
									[options]="this.mapService.bboxArray"
									optionLabel="label" optionValue="bbox"
									[(ngModel)]="this.mapService.zoomSelection"
									(onChange)="boundingBoxSelected(zoomDropdown)">
								</p-select>
							</div>
						</span>

					<div><hr></div>
					
					<!-- 
					  -- Data Display Layers
					  -->
					
					<div><label class="groupHeading">Data Display Layers</label></div>

					<!-- 
				  	  -- Search text box
					  -->
					<div style="padding-left: 20px">
					<data-layer-highlight [displayMatchesTotal]=false (searchItemEvent)="updateSearchItemMatches($event)"></data-layer-highlight>
					</div>

						
					<div class="radio" style="min-height: 15px;"><label>
						<input type="radio" name="optradio"
						id="noDataLayerRadio" value="noDataLayerRadio"
						(click)="dataDisplayLayerClicked($event.target.id)" />None
						</label>
					</div>

					<div class="radio"><label><input type="radio" name="optradio"
						id="precipitationRadio" value="precipitationRadio"
						(click)="dataDisplayLayerClicked($event.target.id)">Precipitation 
						<label *ngIf="(numMatchingPrecipStations!=0 || numMatchingStageStations!=0 || numMatchingStreamflowStations!=0) && (numMatchingPrecipStations==1)" style="width: auto; float: right; padding-left:0px" class='dataDisplayLayerStatus'>({{numMatchingPrecipStations}} match)</label>
						<label *ngIf="(numMatchingPrecipStations!=0 || numMatchingStageStations!=0 || numMatchingStreamflowStations!=0) && (numMatchingPrecipStations!=1)" style="width: auto; float: right; padding-left:0px" class='dataDisplayLayerStatus'>({{numMatchingPrecipStations}} matches)</label>
						</label>

						<div style="display:block" class="anotherLeftSpace"
								pTooltip={{summaryTooltip}}>
								<app-visual-totals [points]="precipCounts"></app-visual-totals>
						</div>

						<div style="display:block; color:#30426a;">
							<p-select
								class="menuDropdown" id="rainfallDataType"
								[options]="this._dataLayerService.getRainfallIntervalOptions()"
								optionLabel="label" optionValue="value"
								[(ngModel)]="this._dataLayerService.rainfallInterval" (onChange)="dataDisplayLayerClicked('rainfallDataType')">
							</p-select>
						</div>

					</div>
					<div class="radio"><label><input type="radio" name="optradio"
						id="stageRadio" value="stageRadio"
						(click)="dataDisplayLayerClicked($event.target.id)">Stage 
						<label *ngIf="(numMatchingStageStations!=0 || numMatchingPrecipStations!=0 || numMatchingStreamflowStations!=0) && (numMatchingStageStations==1)" style="width: auto; float: right; padding-left:0px" class='dataDisplayLayerStatus'>({{numMatchingStageStations}} match)</label>
						<label *ngIf="(numMatchingStageStations!=0 || numMatchingPrecipStations!=0 || numMatchingStreamflowStations!=0) && (numMatchingStageStations!=1)" style="width: auto; float: right; padding-left:0px" class='dataDisplayLayerStatus'>({{numMatchingStageStations}} matches)</label>
						<div style=" display:block"
							pTooltip={{summaryTooltip}}>
							<app-visual-totals [points]="stageCounts"></app-visual-totals>
						</div>
						</label>
					</div>
					
					<div class="radio"><label><input type="radio" name="optradio"
						id="flowRadio" value="flowRadio" (click)="dataDisplayLayerClicked($event.target.id)">Flow 
						<label *ngIf="(numMatchingStreamflowStations!=0 || numMatchingPrecipStations!=0 || numMatchingStageStations!=0) && (numMatchingStreamflowStations==1)" style="width: auto; float: right; padding-left:0px" class='dataDisplayLayerStatus'>({{numMatchingStreamflowStations}} match)</label>
						<label *ngIf="(numMatchingStreamflowStations!=0 || numMatchingPrecipStations!=0 || numMatchingStageStations!=0) && (numMatchingStreamflowStations!=1)" style="width: auto; float: right; padding-left:0px" class='dataDisplayLayerStatus'>({{numMatchingStreamflowStations}} matches)</label>
						<div style=" display:block"
							pTooltip={{summaryTooltip}}>
							<app-visual-totals [points]="flowCounts"></app-visual-totals>
						</div>
						</label>
					</div>

					<!-- start additional data types select -->
					<div class="radio">
						<label><input type="radio" name="optradio"
						id="addnlDataRadio"
						(click)="dataDisplayLayerClicked($event.target.id)">Additional NovaStar Data
						</label>
					</div>
						<!-- pulldown for data types -->
						<div style="display:block; color:#30426a">
							<p-select
								class="menuDropdown"
								id="addnlDataLayerDropdown"
								[options]="this._dataLayerService.getAdditionalDataDisplayLayersDefinitions()"
								optionLabel="label" 
								[(ngModel)]="this._dataLayerService.currentAddnlDataLayer" (onChange)="dataDisplayLayerClicked('addnlDataLayerDropdown')">
							</p-select>
						</div>
					<!-- end additional data types dropdown -->

					<div><hr></div>

					<!-- 
					  -- Overlay Layers
					  -->
					
					<div><label class="groupHeading">Overlay Layers</label></div>
					<div [ngClass]="{doNotCreate:!displayFloodImpactOnMap}" 
						class="checkbox">
						<label><input type="checkbox" 
							id="toggleFloodImpact"
							(click)="menuControlSelected($event)">Flood Impact
							<div style="display:inline"> <br>
								<input type="radio" name="fitDisplay" 
									id="fitDisplayFlow"  checked 
									style="margin-left: 50px"
									(click)="menuControlSelected($event)">flow
								<input type="radio" name="fitDisplay"
									id="fitDisplayCap" 
									(click)="menuControlSelected($event)">cap
							</div>
						<div #fitDiv style="display:block" 
							pTooltip={{summaryTooltip}}>
							<app-visual-totals [points]="fitCounts"></app-visual-totals>
						</div>
						</label>
					</div>

					<!-- This selector allows Operator to dynamically create the overlay layers list -->
					<ng-template dataLayer-host></ng-template>
					
					<div><hr></div>
					
					<!-- 
					  -- Background Layers
					  --  To add a new layer, add the definition to map.service.ts, modify app.component.ts menuControlSelected,
					  -->
					<div><label class="groupHeading">Background Layers</label><label id="BackgroundLayers"></label></div>
				</div>
			</li>
    </ul>
		
		<!-- 
		  -- Help, About, and Support links at the bottom of the side menu
		  -->
        <div class="sidebar-footer">
            <div>
            	<a href={{documentationUrl}} target="_blank">
            		Help
            	</a>
            </div>
            <div>
              <a class="link" (click)="displayVersion()" title={{version}}>
                About
              </a>
            </div>
            <div>
              <a href="http://www.trilynx.systems/support-overview/contact/" target="_blank">
                    Support
              </a>
            </div>
        </div>
    </div>
    <!-- End Sidebar -->

	<!-- 
	  -- Everything else besides side bar
	  -->
    <div id="content-wrapper">
        <div class="page-content">
			<!-- Header Bar -->
			<div class="meta">
				<div id="topMenu" style="padding: 5px 0px 0px 20px">
					<a href="http://trilynx.systems/" target="_blank" title="TriLynx Alert for You" >
					<img src="assets/images/logo_tx_tagline.png" width="119px" height="38px" /></a> 

					<a href={{clientWebsite}} title={{clientWebsite}} target="_blank" >
      				<img id='clientLogo' src={{clientLogo}} [ngClass]={doNotDisplay:!clientLogoExists} height="38px" style="padding-left:25px" /></a>
					
					<label style="color:white; padding-left:25px" title={{version}} id="NOILabel">NovaStar5 Operator Interface</label>
					
					<!-- 
					  -- infoDiv is the area in the top bar on the far right including the last data update
					  -->
					<div id="infoDiv">
						<label id="lastDataUpdateLabel">Last data update:</label>
						<label id="lastDataUpdateTimeLabel">{{timeLabel}}</label>
						<img title="Either an error has occurred reading NovaStar data or data is still being read.  See console for more details." src="assets/images/error-icon-32.png" [ngClass]="{doNotDisplay:!errorVisible}" style="float:left" width="32" height="32">	
						
					</div>
					
					<!-- 
					  -- User avatar
					  -->
					<div id="userButton" class="user"> 
						<div class="item dropdown">
							<a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
								<img src="assets/images/avatar.jpg" width="38" height="38">
							</a>
							<ul class="dropdown-menu dropdown-menu-right">
								<li class="dropdown-header">
									User: {{userName}}
								</li>
								<li class="divider"></li>
								<li class="link">
									<a (click)="checkDisclaimerApprovalRequired(true)" title="View disclaimer and cookies policy" >
										Disclaimer & Cookie 
									</a>
								</li>
								<li class="link">
									<a routerLink="/manageUsers" title="Manage Users">
										Manage Users
									</a>
								</li>
								<li class="link">
									<a routerLink="/manageUsersAdd/{{userName}}" title="Edit {{userName}} information.">
										Profile
									</a>
								</li>
								<li class="link">
									<a routerLink="/configPreferences" title="Display user preferences">
										Preferences
									</a>
								</li>
								<li class="link">
									<a href="javascript:alert('User interface under development.')">  <!-- <a href="javascript:void(0)"> -->
										Server Connection
									</a>
								</li>
								<li class="link">
									<a routerLink="/userMessages" title="Display notifications intended for the user">
										Operator Notifications
									</a>
								</li>
								<li class="divider"></li>
								<li class="link">
									<a [ngClass]="{doNotDisplay:!userLoggedIn}" (click)="logout()" title="Logout" >
										Logout {{userName}}
									</a>
								</li>
								<li class="link">
									<a [ngClass]="{doNotDisplay:userLoggedIn}" (click)="login()" title="Login" >
										Login
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div> 
			</div>    
            <!-- End Header Bar -->
			
			<router-outlet></router-outlet>

			<p-dialog [showHeader]=false header="Status" [(visible)]="displayWaitDialog" [closable]=false>
				<i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>
				Please wait while Operator is processing NovaStar5 data.
			</p-dialog>
			
<p-dialog #cd [style]="{width: '50vw'}" [(visible)]="confirmationDialogVisible">
	<ng-template #header>
		<h3>{{providerOrganizationText}}</h3>
	</ng-template>
	<div class="confirmationFloatLeft">
		<div class="flex flex-column">
			<p class="confirmationRowSeparation"><label class="bold">Terms of use:  </label>{{disclaimerText}}</p>

			<div class="flex flex-row confirmationRowSeparation">
				<p-checkbox [binary]="true" inputId="iagree" (click)="enableConfirmationOK()"></p-checkbox>
				<label for="iagree" class="confirmationText">I agree to the above terms and conditions</label>
			</div>

			<div class="flex flex-row confirmationRowSeparation">
				<p-checkbox [binary]="true" inputId="iagreeCookies" [(ngModel)] = "cookiesOK" ></p-checkbox>
				<label for="iagreeCookies" class="confirmationText" >I agree to allow cookies for basic application functionality including remembering user login and terms of use acknowledgement.</label>
			</div>

			<div class="flex flex-row confirmationRowSeparation">
				<p-checkbox [binary]="true" inputId="doNotShowAgain" [disabled]="!cookiesOK" [(ngModel)]="confirmationCBTextDoNotShow"></p-checkbox>
				<label for="doNotShowAgain" class="confirmationText" [ngClass]="{'textDisabled': !cookiesOK}">Do not show again (requires approval of cookies).</label>
			</div>
		</div>
		<div class="flex" style="justify-content: center; margin-top: 40px">
			<button type="button" pButton icon="pi pi-check" label="OK" [disabled]="confirmationDialogDisabled" (click)="closeConfirmationDialog()"></button>
		</div>
	</div>
</p-dialog>

        </div><!-- End Page Content -->
    </div><!-- End Content Wrapper -->
</div><!-- End Page Wrapper -->


